export { default as MovieDetailCardWithVideo_1 } from "./MovieDetailCardWithVideo_1";
